import React, { useEffect } from "react";
import styles from "../GetInvolved/Modal1.module.css";

const Modal1 = ({ open, onClose, title, subTitle, children }) => {
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "auto";
  }, [open]);

  if (!open) return null;


  
   const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose && onClose();
    }
  };

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={styles.ModalMain}>
        <div className={styles.modal}>
          <div className={styles.headerBar}>
            <div>
              {subTitle && <h4 className={styles.subTitle}>{subTitle}</h4>}
              {title && <h2 className={styles.title}>{title}</h2>}
            </div>
            <div className={styles.closeBtn} onClick={onClose}>
              <img src="/Svg/Cross-icon.svg" alt="Cross-icon" />
            </div>
          </div>

          {/* ✅ Form or any content will be injected here */}
          <div className={styles.content}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default Modal1;
